RivalIQ.apps.Shell.module('utils', function (utils, App, Backbone, Marionette, $, _, moment) {

    'use strict';

    utils.convertToDay = function (date) {
        return new Date(date.get('year'), date.get('month'), date.get('date'));
    };

    utils.getDataFreshnessState = function () {

        const stalestSocialData = RivalIQ.state.landscape.get('stalestSocialData');
        const companyAdded = RivalIQ.state.landscape.get('companyAdded');
        const socialDataAgeMinutes = moment.utc().diff(stalestSocialData, 'minutes', true);
        const socialDataAgeHours = Math.ceil(socialDataAgeMinutes / 60);

        // NOTE if things are really stale, cap the displayed number
        const socialDataAgeText = (socialDataAgeHours > 24 ? '> 24 hours' : `< ${
            RivalIQ.formatter.formatLabeledNumber('hour', 'hours', socialDataAgeHours)}`);

        // NOTE we'll only show the update in flight / complete things if it appears that an update is necessary
        const plan = RivalIQ.state.account.get('plan');
        const needsUpdate = (companyAdded || (socialDataAgeMinutes > plan.class_1_data_freshness_minutes));

        const landscapeDataUpdateStatus = RivalIQ.state.landscape.get('landscapeDataUpdateStatus');
        const postTagUpdateStatus = RivalIQ.state.landscape.get('postTagUpdateStatus');

        return {
            socialDataAgeText: socialDataAgeText,
            updateInFlight: (needsUpdate && landscapeDataUpdateStatus === RivalIQ.data.DataUpdateStates.UPDATE_IN_FLIGHT),
            updateComplete: (needsUpdate && landscapeDataUpdateStatus === RivalIQ.data.DataUpdateStates.UPDATE_COMPLETE),
            postTagUpdateStatus: postTagUpdateStatus
        };

    };

    utils.sanitizeDateInput = function (dateString) {
        // we support the following format:
        // MM/DD/YYYY
        // MM/DD/YY
        // M/D/YY
        // M/D/YYYY
        // MMDDYY

        dateString = dateString || '';
        dateString = dateString.trim();

        // split on anything that's not a number
        let components = _.compact(dateString.split(/[^0-9]/));
        if (components.length === 1) {
            // lets try to parse the date as MMDDYY or MMDDYYYY
            components = [];
            const monthString = dateString.slice(0, 2);
            components.push(monthString);
            dateString = dateString.slice(2);

            const dayString = dateString.slice(0, 2);
            if (dayString) {
                components.push(dayString);
                dateString = dateString.slice(2);
            }

            if (dateString.length) {
                if (dateString.length === 2) {
                    components.push(dateString);
                } else {
                    components.push(dateString.slice(0, 4));
                }
            }
        }

        // pad any numbers that are only 1 digit long
        const paddedCompnents = _.map(components, function (numString, i) {
            // don't pad year, should always be in YYYY format
            if (i === 2) {
                return numString;
            } else if (numString.length) {
                return _.padStart(numString, 2, '0');
            }
        });

        // rejoin with standard separator
        return paddedCompnents.join('/');
    };

    utils.findActiveItem = function (collection, predicate) {
        return collection.find(function (model) {

            if (model.get('isGroup')) {
                return _.find(model.get('items'), function (item) {
                    return predicate(item);
                });
            }

            return predicate(model.attributes);
        });
    };

}, window.moment);
